import { http } from '@/core/helpers/http.helper';
import { MessageBulkUpdate } from './message-bulk-update.interface';
import { ApiResource } from '@/core/models/api-resource.interface';
import { Message } from '../message.interface';
export class MessageBulkUpdateService {
   async getMessageBulkUpdates() {
      throw Error('Method not implemented');
   }

   async getMessageBulkUpdate() {
      throw Error('Method not implemented');
   }

   async postMessageBulkUpdate() {
      throw Error('Method not implemented');
   }

   async putMessageBulkUpdate(messageBulkUpdate: MessageBulkUpdate) {
      const response = await http.put<ApiResource<Array<Message>>>('/communications/messages/bulk-update-fields', messageBulkUpdate);
      return response.data.data;
   }

   async deleteMessageBulkUpdate() {
      throw Error('Method not implemented');
   }
}
